import api from "../lib/api";

export interface IstatsService{
    getProjectStats: (lokacijaId: number) => Promise<any>;
    getFishnetStats: (lokacijaId: number, lokacijaId2: number) => Promise<any>;
}
const statsService: IstatsService = {
    getProjectStats,
    getFishnetStats
};

export function getProjectStats(selProID: number){
    const apiInstance = new api();
    const url = "operations/projekti/"+ Number(selProID) +"/stats/";
    return apiInstance.Call(url, "get");
}
export function getFishnetStats(selProID: number, selFishID: number){
    const apiInstance = new api();
    const url = "operations/projekti/"+ Number(selProID) +"/fishnets/"+ Number(selFishID) +"/stats/";

    return apiInstance.Call(url, "get");
}
export default statsService;

